import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 62.43 32.12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.82 26.59c8.26-6.7 14.17-12.44 15.92-15.55.75-1.2.99-2.35.57-3.28-.77-1.74-3.49-2.27-6.85-1.61A260.62 260.62 0 0 1 62.14 0c.15 0 .28.12.29.27 0 .12-.07.23-.19.27-19.46 6.33-37.18 16.57-52.23 29.83-.02.02-.04.03-.06.03l-9.8 1.72c-.14.03-.21-.15-.1-.24 2.29-1.73 4.54-3.49 6.77-5.29",
      style: {"fill-rule":"evenodd","fill":"#d81e05"}
    }, null, -1),
    _createElementVNode("path", {
      d: "m5.51 8.75-.65.18c-.13.03-.12.22.02.24l3.71.53 6.48.93s.05 0 .07-.01c4.56-2.18 7.6-3.02 8.27-2.07.21.29.17.74-.07 1.33-.08.2-.19.41-.32.64.71-1.13.94-2.22.55-3.1-.74-1.65-3.34-2.14-6.55-1.52-3.86.86-7.7 1.82-11.51 2.86",
      style: {"fill":"#93282c","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "OS-logo"}) } }